import { createEventBus } from "../eventBusFactory";

export const OPEN_BRACKET_FIGHTS_OVER_VIEW_SIDEBAR = "openBracketFightsOverViewSidebar";

export const singleFightEventBus = createEventBus();
